import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { SetService } from 'ngx-block-core';
import { FormGroup } from '@angular/forms';
import { FormControlService } from "ngx-block-core";
import { selectSize } from "../../../data/data";
import { GeneralPipe } from 'ngx-block-core';
import { filter, distinctUntilChanged, debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-sucu04-weiget0010003',
  templateUrl: './sucu04-weiget0010003.component.html',
})
export class Sucu04Weiget0010003Component implements OnInit {


  @Input() local = false;
  @Input() static = false;
  @Input() blockid = "-1";
  @Input() layoutid = "-1";
  @Input() form: FormGroup;
  @Input() nzFormGroupData;
  @Input() nzLayout = 'horizontal'

  @Input() sets = {
    blockCode: "sucublock30",
    blockId: "",
    blockName: "数字输入框",
    layoutId: "",
    blockType: 'formBlock',
    blockChildType: '',
    versionCode: 10,
    attributes: ['form', 'nzFormGroupData', 'nzLayout'],
    events: [
      {
        label: "重置",
        value: "reset",
        data: {}
      },
      {
        label: "可用不可用",
        value: "isable",
        data: {
          setParams: ["不可用值", '可用值', 'reset,disablevalue(例:disablevalue,1),enablevalue']
        }
      },
      // {
      //   label: "隐藏",
      //   value: "pageShow",
      //   data: {
      //     setParams: ["隐藏值", '显示值，可不填', '备用']
      //   }
      // }
    ],
    styles: {
      nzTextColor: "",
      nzSize: "default",
      nzPlaceHolder: "请输入内容",
      nzLayout: {
        nzLayout1: 0,
        nzLayout2: 8,
        nzLayout3: 0,
        nzLayout4: 16,
        nzAlign: 'left',
        nzMarginBottom: 3,
        nzLineHeight: 1.4,
        nzFontSize: 12
      },
      nzRequired: false,
      nzHasFeedback: true,
      nzMin: 1,
      nzMax: 1000,
      nzStep: 1,
      nzReadOnly: false,
      nzFormat: "",
      nzDecimalPipe: "",
      nzNoSee: false,
      nzFocus: false,
      nzFocusMove: "",
      nzDebounceTime: 500,
      nzExpandId: "",
    },
    datas: {
      nzSearchDataType: "string|array",
      nzSearchType: "=",
      nzSameTableCalculate: {
        nzUsed: false,
        nzFormula: "",
        nzReplaceValue: [
          // {
          //   name:"@v1",
          //   field:"",
          // }
        ]
      },
      nzLinkage: {
        nzUsed: false,

        nzEvents: [
          // {
          //   blockid:blockid,
          //   type:"value"//value,datasource
          // }
        ],//blockid
      },
      nzLinkageData: {
        nzLinkageType: "default",//group
        nzDynamicSql: "",
        nzGroupLinkageRule: "",
        nzGroupRules: {
          linkage1: "",
          linkage2: "",
          linkage3: "",
          linkage4: ""
        }
      }
    }
  };

  nzFormatter
  nzParser
  setData = []

  constructor(
    public setService: SetService,
    private formControlService: FormControlService,
    private generalPipe: GeneralPipe,
    private elementRef: ElementRef
  ) { }
  ngOnInit() {

    this.baseInit();



    if (this.sets.styles.nzFormat != "") {
      const arr = this.sets.styles.nzFormat.split("@value")
      if (this.sets.styles.nzDecimalPipe != "")
        this.nzFormatter = value => this.sets.styles.nzFormat.replace('@value', this.generalPipe.transform(value, 'numerical', this.sets.styles.nzDecimalPipe, 'value'));
      else
        this.nzFormatter = value => this.sets.styles.nzFormat.replace('@value', value);
      if (arr.length > 1)
        this.nzParser = value => value.replace(arr[0], '').replace(arr[1], '');
      else
        this.nzParser = value => value.replace(arr[0], '');
    } else {
      if (this.sets.styles.nzDecimalPipe != "")
        this.nzFormatter = value => this.generalPipe.transform(value, 'numerical', this.sets.styles.nzDecimalPipe, 'value');
      else
        this.nzFormatter = value => value;
      this.nzParser = value => value;
    }

    this.autoUpdate();

    let control_name = this.nzFormGroupData.nzKey;
    this.form.get(control_name).valueChanges.pipe(
      //同valueChanges，不写也可
      distinctUntilChanged(),
      //防抖时间，单位毫秒
      debounceTime(this.sets.styles['nzDebounceTime']),
    ).subscribe((val) => {
      console.log("valueChangesval", val);
      if (val != "" && this.sets.styles['nzFocusMove'] != '' && this.sets.styles['nzFocusMove'] != this.blockid) {
        console.log("move-focus", this.sets.styles['nzFocusMove'])
        try {
          this.setService.events[this.sets.styles['nzFocusMove']].emit({
            type: "focus",
            datas: {}
          });
        } catch (error) {
          console.log("move-focus", error)
        }

      }




      this.formControlService.dataEvent(val, this.nzFormGroupData, this.blockid)
      if (this.needCalculate.used) {
        this.setService.events[this.needCalculate.id].emit({
          type: 'changeCalculateValue',
        });
      }

      //联动
      console.log("nzLinkage", JSON.stringify(this.sets.datas.nzLinkage));
      if (this.sets.datas.nzLinkage.nzUsed) {
        this.sets.datas.nzLinkage.nzEvents.forEach(element => {
          console.log("element", JSON.stringify(element));
          this.setService.sendEvent(element.blockid, "linkage" + element.type, { value: val })
        });
      }

    });

    if (this.sets.styles.nzReadOnly) this.form.get(this.nzFormGroupData.nzKey).disable();
    else this.form.get(this.nzFormGroupData.nzKey).enable();
    // this.form.get(control_name).patchValue('4');

  }
  autoUpdate() {

    //v3,升级自定义表单参数
    if (this.sets.versionCode < 3) {

      this.sets.blockCode = "sucublock30";

      this.sets.versionCode = 3;
    }
    //vc:4
    //联动
    if (this.sets.versionCode < 4) {
      if (typeof this.sets.datas.nzLinkage == "undefined") {
        this.sets.datas['nzLinkage'] = {
          nzUsed: true,
          nzEvents: [

          ],
        };
        this.sets.datas['nzLinkageData'] = {
          nzLinkageType: "default",//group
          nzDynamicSql: "",
          nzGroupLinkageRule: "",
          nzGroupRules: {
            linkage1: "",
            linkage2: "",
            linkage3: "",
            linkage4: ""
          }
        }
      }
      this.sets.versionCode = 4;
    }
    //v3,升级自定义表单参数
    if (this.sets.versionCode < 5) {
      if (typeof this.sets.styles.nzNoSee == "undefined")
        this.sets.styles.nzNoSee = false;
      this.sets.versionCode = 5;
    }

    if (this.sets.versionCode < 6) {
      this.sets.styles['nzDebounceTime'] = 500;
      this.sets.styles['nzFocusMove'] = "";
      this.sets.styles['nzFocus'] = false;

      this.sets.versionCode = 6;
    }


    if (this.sets.versionCode < 8) {

      this.sets.styles['nzExpandId'] = "";
      this.sets.versionCode = 8;
    }

    if (this.sets.versionCode < 10) {

      this.sets.events =
        [
          {
            label: "重置",
            value: "reset",
            data: {}
          },
          {
            label: "可用不可用",
            value: "isable",
            data: {
              setParams: ["不可用值", '可用值', 'reset,disablevalue(例:disablevalue,1),enablevalue']
            }
          },
          // {
          //   label: "隐藏",
          //   value: "pageShow",
          //   data: {
          //     setParams: ["隐藏值", '显示值，可不填', '备用']
          //   }
          // }
        ]
      this.sets.versionCode = 10;
    }

  }
  /**
   * 计算功能初始化
   */
  initCalculate(open = true) {
    if (this.sets.datas.nzSameTableCalculate.nzUsed || open == false) {
      this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {

        this.setService.events[element.field].emit({
          type: 'needCalculate',
          datas: {
            used: open,
            id: this.blockid,
            name: element.name
          }
        });
      });
      if (open)
        this.calculateValue()
    }
  }
  /**
   * 计算数值
   */
  calculateValue() {
    let nzFormula = this.sets.datas.nzSameTableCalculate.nzFormula;
    //取值,替换值
    this.sets.datas.nzSameTableCalculate.nzReplaceValue.forEach(element => {
      console.log("calculate_name_key:" + element.name, JSON.stringify(this.calculate_name_key));
      const value = this.form.get(this.calculate_name_key[element.name]).value;
      nzFormula = nzFormula.replace(new RegExp(element.name, "gm"), value);
    });

    try {
      console.log("nzFormula:" + nzFormula);
      this.form.get(this.nzFormGroupData.nzKey).patchValue(eval(nzFormula));
      console.log("nzFormulare:" + this.form.get(this.nzFormGroupData.nzKey).value);
    } catch (error) {

    }


  }
  needCalculate = {
    used: false,
    id: "",
    name: ""
  };
  calculate_name_key = {}
  Listening() {
    console.log("Listening-number", this.blockid)
    this.setService.initEvent(this.blockid);
    this.setService.events[this.blockid].subscribe(
      data => {
        console.log('Listening', JSON.stringify(data));
        let array0 = [];
        let array1 = [];
        let array2 = [];
        switch (data['type']) {
          case 'needCalculate':
            //通知目标积木更新值后通知回来
            this.needCalculate = data.datas;
            this.setService.events[this.needCalculate.id].emit({
              type: 'setCalculate',
              datas: {
                name: this.needCalculate.name,
                key: this.nzFormGroupData.nzKey
              }
            });
            break;
          case 'setCalculate':
            this.calculate_name_key[data.datas.name] = data.datas.key;
            break;
          case 'changeCalculateValue':
            this.calculateValue()
            break;
          case 'focus':
            // console.log('ViewChild获取匹配的元素2:', this.elementRef.nativeElement.querySelector('nz-input-number'));
            // console.log("elementRef", this.elementRef.nativeElement)

            // this.elementRef.nativeElement.querySelector('nz-input-number').focus();
            break;
          case 'reset':
            this.form.get(this.nzFormGroupData.nzKey).patchValue('')
            this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
            this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
            break;
          case 'isable':

            console.log("isable")
            array0 = (data.datas.param0 + "").split(",");
            array1 = (data.datas.param1 + "").split(",");
            array2 = (data.datas.param2 + "").split(",");
            console.log("array0,1", array0, array1)
            if (array0.indexOf(data.datas.value) >= 0) {

              this.form.get(this.nzFormGroupData.nzKey).disable();
              this.sets.styles.nzReadOnly = true;
              console.log("setdis", this.sets.styles.nzReadOnly)
              if (array2.indexOf('reset') >= 0) {
                this.form.get(this.nzFormGroupData.nzKey).patchValue('')
                this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
              }
              const disableIndex = array2.indexOf('disablevalue');
              if (disableIndex >= 0 && array2[disableIndex + 1]) {
                this.form.get(this.nzFormGroupData.nzKey).patchValue(array2[disableIndex + 1])
                this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
              }
            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
              // enable

              this.sets.styles.nzReadOnly = false;
              console.log("seten", this.sets.styles.nzReadOnly)
              this.form.get(this.nzFormGroupData.nzKey).enable();
              const enableIndex = array2.indexOf('enablevalue');
              if (enableIndex >= 0 && array2[enableIndex + 1]) {
                this.form.get(this.nzFormGroupData.nzKey).patchValue(array2[enableIndex + 1])
                this.form.get(this.nzFormGroupData.nzKey).markAsDirty();
                this.form.get(this.nzFormGroupData.nzKey).updateValueAndValidity();
              }
            }
            break;
          case 'pageShow':

            console.log("data.datas.value", data.datas.value, data.datas.param0, data.datas.value == data.datas.param0)
            array0 = (data.datas.param0 + "").split(",");
            array1 = (data.datas.param1 + "").split(",");
            if (array0.indexOf(data.datas.value) >= 0) {
              //disable
              this.sets['styles']['nzHidden'] = true;

            } else if (array1.indexOf(data.datas.value) >= 0 || data.datas.param1 == "") {
              // enable
              this.sets['styles']['nzHidden'] = false;
              // this.form.get(this.nzFormGroupData.nzKey).enable();
            }
            break;
          default:
            break;
        }


      }
    )
    setTimeout(() => {
      this.initCalculate()
    }, 100);
    console.log("Listening-number2", this.blockid)

  }


  setDataInit() {
    this.setData = [
      {
        tabName: '数据',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormDataSource' },
              {
                name: 'nzFormSearchType',
                inputs: {
                  numberFormat: true
                }
              },
              { name: 'nzLinkage', inputs: { nzBlockSets: this.sets } },

            ]
          }
        ]
      },
      {
        tabName: '样式',
        datas: [
          {
            type: 'styles',
            data: [
              {
                name: 'input',
                inputs: { nzText: "积木名称 : ", nzKeys: ['blockName'] }
              },
              {
                name: 'color',
                inputs: { nzText: "文字颜色 : ", nzKeys: ['styles', 'nzTextColor'] }
              },
              {
                name: 'input',
                inputs: { nzText: "提示文字 : ", nzKeys: ['styles', 'nzPlaceHolder'] }
              },
              {
                name: 'number',
                inputs: { nzText: "步长 : ", nzKeys: ['styles', 'nzStep'] }
              },
              {
                name: 'input',
                inputs: { nzText: "数值管道 : ", nzKeys: ['styles', 'nzDecimalPipe'], nzPlaceHolder: "3.2-4" },
                outputs: {
                  ngModelChange: () => { //应用正则校验下。。。
                    this.setService.onReLoadbBlock(this.layoutid)
                  }
                }
              },
              {
                name: 'input',
                inputs: { nzText: "数值渲染 : ", nzKeys: ['styles', 'nzFormat'], nzPlaceHolder: "$@value%" },
                outputs: { ngModelChange: () => { if (this.sets.styles.nzFormat.indexOf('@value') >= 0) this.setService.onReLoadbBlock(this.layoutid) } }
              },
              {
                name: 'input',
                inputs: { nzText: "最大值 : ", nzKeys: ['styles', 'nzMax'], nzPopContent: "请输入有效数字，无穷大：Infinity" }
              },
              {
                name: 'input',
                inputs: { nzText: "最小值 : ", nzKeys: ['styles', 'nzMin'], nzPopContent: "请输入有效数字，无穷小：-Infinity" }
              },
              {
                name: 'switch',
                inputs: { nzText: "只读 : ", nzKeys: ['styles', 'nzReadOnly'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.form.get(this.nzFormGroupData.nzKey).disable();
                    else
                      this.form.get(this.nzFormGroupData.nzKey).enable();
                  }
                }
              },
              {
                name: 'nzLayout'
              },
              {
                name: 'radio',
                inputs: { nzText: "大小 : ", nzKeys: ['styles', 'nzSize'], nzData: selectSize }
              },
              {
                name: 'switch',
                inputs: { nzText: "显示必填* : ", nzKeys: ['styles', 'nzRequired'], nzPopContent: ['仅影响样式'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "校验图标 : ", nzKeys: ['styles', 'nzHasFeedback'], nzPopContent: ['校验状态的图标'] }
              },
              {
                name: 'switch',
                inputs: { nzText: "表单忽视 : ", nzKeys: ['styles', 'nzNoSee'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzSearchDataType'] = "noSee";
                    else
                      this.nzFormGroupData['nzSearchDataType'] = "string|array";
                  }
                }
              },
              {
                name: 'switch',
                inputs: { nzText: "自动焦点 : ", nzKeys: ['styles', 'nzFocus'] },
                outputs: {
                  ngModelChange: (event) => {
                    if (event)
                      this.nzFormGroupData['nzValue']['nzValueFormat'] = "focus";
                    else
                      this.nzFormGroupData['nzValue']['nzValueFormat'] = "yyyy-mm-dd hh24:mi:ss";
                  }
                }

              },
              {
                name: 'select',
                inputs: { nzText: "焦点转移 : ", nzKeys: ['styles', 'nzFocusMove'], nzData: this.setService.getBlock('formBlock', "*") },
              },
              {
                name: 'number',
                inputs: { nzText: "防抖时间 : ", nzKeys: ['styles', 'nzDebounceTime'] }
              },
            ]
          },
        ]
      },

      {
        tabName: '表单',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzFormSet' },
            ]
          }
        ]
      },
      {
        tabName: '高级功能',
        datas: [
          {
            type: 'datas',
            data: [
              { name: 'nzSameTableCalculate' }
            ]
          }
        ]
      }
    ]
  }


  baseInit() {

    if (!this.local) {//非本地
      if (!this.static) {//非静态
        if (this.setService.blocksort[this.blockid]['sets'] !== "{}") {
          this.sets = this.setService.blocksort[this.blockid]['sets'];
        } else {
          this.setService.blocksort[this.blockid]['sets'] = this.sets;
        }
        this.sets.blockId = this.blockid;
        this.sets.layoutId = this.layoutid;
        this.nzFormGroupData['nzSearchDataType'] = "string|array";
        if (this.sets.styles.nzNoSee == true)
          this.nzFormGroupData['nzSearchDataType'] = "noSee";
        this.nzFormGroupData['nzSearchType'] = "=";
        this.setDataInit();
        if (typeof this.setService.setDatas[this.blockid] == 'undefined') {
          this.setService.setDatas[this.blockid] = this.setData;
        }

        this.pzListening()
      }
      else {//静态
        if (typeof this.sets == "string")
          this.sets = JSON.parse(<any>this.sets);
        this.blockid = this.sets.blockId;
        this.layoutid = this.sets.layoutId;
      }
    }
    this.Listening();
  }

  ngOnDestroy() {
    console.log('000ngngOnDestroy执行了-bumber', this.blockid);
    if (!this.static) this.setService.deleteEvent(this.blockid, 'pz')
    this.setService.deleteEvent(this.blockid);
  }

  pzListening() {
    setTimeout(() => {

      this.setService.initEvent(this.blockid, 'pz');
      this.setService.pzEvents[this.blockid].subscribe(data => {
        console.log('Listeningpz', JSON.stringify(data));

        switch (data['type']) {
          case 'changeFormValid':
            this.formControlService.setValidators(this.form, this.nzFormGroupData.nzKey, this.nzFormGroupData);
            break;
          case 'openCalculate':
            if (data.datas == true) {

              this.initCalculate();
            } else {
              this.sets.datas.nzSameTableCalculate.nzUsed = false;
              this.initCalculate(false)
            }
            break;

          default:
            break;
        }
      }
      )
    }, 100);

  }


}
